import useLivlyUser from "../context/UserProvider";
import { ServiceTypeEnum } from "../types/Building";

export type RequireFeedbackCommentType = "All" | "None" | "NegativeOnly";

interface FeedbackMetaData {
  requireComment?: RequireFeedbackCommentType;
}

export default function useGetFeedbackRequireComment(): RequireFeedbackCommentType {
  const { user } = useLivlyUser();
  let requireFeedbackComment: RequireFeedbackCommentType = "None";

  const buildingFeedbackService = user.building?.serviceTypes?.find(
    (st) => st.serviceType === ServiceTypeEnum.ResidentFeedback
  );

  if (buildingFeedbackService?.metaData) {
    try {
      const parsedMetaData = JSON.parse(
        buildingFeedbackService.metaData
      ) as FeedbackMetaData;
      requireFeedbackComment = parsedMetaData.requireComment ?? "None";
    } catch {
      // If metaData is malformed JSON, fall back to the default value.
      requireFeedbackComment = "None";
    }
  }

  return requireFeedbackComment;
}
